import React from 'react';
import './Services.css';
import pomocDrogowaIcon from '../assets/pomoc-drogowa.png';

const Services = () => {
  const services = [
    {
      title: "Remonty kapitalne silników spalinowych",
      icon: "🔧"
    },
    {
      title: "Serwis klimatyzacji",
      icon: "❄️"
    },
    {
      title: "Diagnostyka komputerowa",
      icon: "💻"
    },
    {
      title: "Serwis ogumienia",
      icon: "🛞"
    },
    {
      title: "Regeneracja głowic",
      icon: "⚙️"
    },
    {
      title: "Szlifowanie wałów korbowych",
      icon: "🔩"
    },
    {
      title: "Regeneracja korbowodów",
      icon: "🛠️"
    },
    {
      title: "Mechanika pojazdowa",
      icon: "🚗"
    },
    {
      title: "Czyszczenie filtrów DPF / FAP",
      icon: "🧼"
    },
    {
      title: "Pomoc drogowa",
      icon: (
        <img
          className="service-icon-img"
          src={pomocDrogowaIcon}
          alt=""
          aria-hidden="true"
        />
      )
    }
  ];

  return (
    <section id="services" className="services section-padding">
      <div className="container">
        <h2 className="section-title">Nasze Usługi</h2>
       
        
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
